// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from '@/store/store.js'
import moment from 'moment'
import VeeValidate, {Validator} from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN'

import App from './App'
import router from './router'
import { formatSize } from './util'

Vue.config.productionTip = false

moment.locale()
Vue.filter('pad0', function (value, targetLength = 2) {
  return ('' + value).padStart(targetLength, '0')
})
Vue.filter('date', function (value) {
  return moment(value).format('YYYY-MM-DD')
})
Vue.filter('size', function (value) {
  return formatSize(value)
})

// 配置 vee-validate
Validator.localize('zh-CN', zh)
Vue.use(VeeValidate)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js